<template>
  <div>
    <PcContainer :channelData="channelData">
      <template slot="center">
        <div class="container-center-center">
          <p class="tips" style="font-size:16px;color:#646464;">访问前，请完成手机验证</p>
          <van-form class="form">
            <van-field
              v-model="ruleForm.phone"
              :maxlength="11"
              type="tel"
              placeholder="请输入手机号"
              class="input"
              style="margin-bottom: 0.56rem"
            ></van-field>
            <div class="flexBox">
              <van-field
                v-model="ruleForm.verifyCode"
                :maxlength="4"
                type="tel"
                placeholder="请输入验证码"
                class="input"
                style="margin-bottom: 0.16rem; width: 254px"
                use-button-slot
              ></van-field>
              <XrkSlideVerify
                ref="verification"
                :options="verificationOptions"
                @success="checkSuccessful"
                @close="verifyClose"
              >
                <van-button
                  size="large"
                  style="height: 40px; margin-left: 15px;width:98px;border-radius: 3px;"
                  color="#3667EC"
                  square
                  @click="goSms"
                  :disabled="sendLock || !agreement"
                >{{ sendText }}</van-button>
              </XrkSlideVerify>
            </div>
          </van-form>
          <p style="color: red; margin: 10px; height: 40px">{{ errMsg }}</p>
          <van-checkbox v-model="agreement" class="checkbox">
            我同意遵守
            <span style="color: #3667ec" @click="jump">《医生汇聚合SaaS使用服务协议》</span>
          </van-checkbox>
          <van-button
            size="large"
            style="height: 40px; width: 368px; margin-top: 16px;border-radius: 3px;"
            color="#3667EC"
            square
            @click="goHome"
            :disabled="!ruleForm.verifyCode"
          >确认登录</van-button>
        </div>
      </template>
    </PcContainer>
  </div>
</template>

<script>
import PcContainer from '@/components/pclogin/pcContainer';
import { customerUser, getVerification } from '@/api/ajax';
import { mapActions } from 'vuex';
import { syncUserInfo } from '@/utils/storage';
import { jumpBeforeRegisterUrl } from '@/utils/storage';

export default {
  name: 'pcRegiser',
  components: {
    PcContainer
  },
  props: {
    channelData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      timer: null,
      agreement: true,
      sendText: '获取验证码',
      sendLock: false,
      errMsg: '',
      verificationOptions: {
        // 接口请求 防抖
        remoteTimerInterval: 800,
        errorText: '请控制拼图块对齐缺口',
        successText: '验证成功',
        remoteApi: {
          initImages: getVerification,
          checkVerification: position => {
            return customerUser.sendMessageCode({
              ...this.ruleForm,
              ...position
            });
          }
        }
      },
      ruleForm: {
        phone: '',
        verifyCode: ''
      }
    };
  },
  methods: {
    ...mapActions(['savePhone']),
    async goHome() {
      const {
        data: { data }
      } = await customerUser.verifyLogin({
        phone: this.ruleForm.phone,
        verifyCode: this.ruleForm.verifyCode
      });
      let { token, user, channel, tJhEnterpriseChannelWhiteList } = data;
      user.token = token;
      await syncUserInfo(user);
      this.$sa.login(user.id);
      if (channel.userPerfectType === 1 && !user.fullName) {
        this.$router.push({
          name: 'perfect'
        });
      } else if (channel.visitRestrictType === 3) {
        this.$router.push({
          name: 'word'
        });
      } else if (
        channel.visitRestrictType === 4 &&
        !tJhEnterpriseChannelWhiteList
      ) {
        //不在白名单里面
        this.$router.push({
          name: 'word'
        });
      } else {
        let jumpUrl = jumpBeforeRegisterUrl();
        if (!jumpUrl) {
          this.$router.push({
            name: 'home'
          });
        }
      }
    },
    checkSuccessful() {
      this.timer && clearInterval(this.timer);
      this.timer = setInterval(() => {
        if (this.sendText > 0) {
          this.sendText -= 1;
        } else {
          clearInterval(this.timer);
          this.sendText = '获取验证码';
          this.sendLock = false;
        }
      }, 1000);
      this.savePhone(this.ruleForm);
    },
    validate(item) {
      this.errMsg = '';
      if (/^1[0-9]{10}$/.test(item)) {
        return true;
      } else {
        return false;
      }
    },
    jump() {
      window.location.href =
        'https://cdn.yxvzb.com/WEB/SaaS/polymerization/agreement/c.html?t=' +
        Date.now();
    },
    goSms() {
      const toNext = () => {
        this.sendLock = true;
        this.sendText = 60;
        this.$refs['verification'].visible = true;
      };
      if (!this.validate(this.ruleForm.phone)) {
        this.$toast('请输入正确的手机号');
      } else if (!this.agreement) {
        this.$toast('请阅读用户协议并遵守');
      } else {
        if (this.channelData.visitRestrictType == 5) {
          customerUser
            .queryWhiteList({
              phone: this.ruleForm.phone
            })
            .then(res => {
              if (res.data.data == 1) {
                toNext();
              } else {
                this.errMsg = res.data.message;
              }
            });
        } else {
          toNext();
        }
      }
    },
    verifyClose() {
      clearInterval(this.timer);
      this.sendText = '获取验证码';
      this.sendLock = false;
    }
  },
  beforeDestroy() {
    this.timer && clearInterval(this.timer);
  }
};
</script>

<style lang="less" scoped>
.form {
  margin-top: 37px;
  .van-cell {
    padding: 0;
    width: 368px;
    height: 40px;
    background: #f6f6f6;
    margin: 0 0 0 72px;
    /deep/input {
      padding-left: 18px;
      font-size: 14px !important;
      height: 40px;
    }
  }
  p {
    font-size: 0.32rem;
    color: #323235;
    &.tips {
      font-size: 0.37rem;
      color: #acacac;
      line-height: 0.61rem;
      margin-bottom: 0.43rem;
    }
  }
}
.checkbox {
  margin-left: 72px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
</style>
